/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import { Upload, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';
import {
    handleProdcutMultipleImage,
    handleFeaturedImage,
    resetFeatureImage,
} from '../../redux/products/productsActions';
import DokanIcons from '../icon/DokanIcons';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
function DokanUpload() {
    const [isHovered, setHover] = useState(false);
    const [hideFeature, setHideFeature] = useState(true);
    const dispatch = useDispatch();
    const { featureImage } = useSelector((state) => state.products.productInputData);
    const { coverImageLoader } = useSelector((state) => state.products);
    // const source_url = images.length > 0 ? images[0] : '';
    const uploadButton = (
        <div>
            <div style={{ marginTop: 8 }}>+</div>
        </div>
    );
    const removeCoverImage = (data) => {
        // console.log(data);
        dispatch(resetFeatureImage(data));
    };
    const getBase64 = (file, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(file);
    };
    const handlefileUpload = (file) => {
        // Get this url from response in real world.
        console.log('file');
    };

    const inputFile = () => {
        const input = document.createElement('input');
        console.log(input);
        input.type = 'file';
        input.onchange = (e) => {
            // you can use this method to get file and perform respective operations
            const files = Array.from(input.files);
            // eslint-disable-next-line no-use-before-define
            onFileChange(files[0]);
        };
        input.click();
    };

    const onFileChange = (fileInput) => {
        const file = fileInput;
        const data = {
            name: '',
            image: '',
        };

        const form = new FormData();
        form.append('productImage', file, file.name);
        dispatch(handleFeaturedImage(file.name, file));
    };
    useEffect(() => {
        (function feature() {
            return Object.keys(featureImage).length !== 0
                ? setHideFeature(false)
                : setHideFeature(true);
        })();
    }, [featureImage]);
    return (
        <>
            <div className="">
                {/* <div className="cover-image-box flex items-center justify-center ">
                    <div className="border border-gray-DEFAULT border-dotted relative">
                        {hideFeature ? (
                            <button
                                type="button"
                                className="avatar-multi-uploader p-20"
                                onClick={inputFile}
                            >
                                +
                            </button>
                        ) : (
                            <div
                                onMouseOver={() => setHover(true)}
                                onMouseLeave={() => setHover(false)}
                            >
                                <img
                                    src={featureImage.src}
                                    alt="img"
                                    className="avatar-multi-uploader w-full h-full"
                                />
                                {isHovered && (
                                    <button
                                        type="button"
                                        style={{
                                            position: 'absolute',
                                            top: '-10px',
                                            right: '-10px',
                                        }}
                                        onClick={() => removeCoverImage({})}
                                    >
                                        <DokanIcons icon="#cross_oval" size="6" />
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                     </Spin> 
                </div> */}
                {/** new cover image box */}
                <Spin
                    spinning={coverImageLoader}
                    className="-ml-40"
                    indicator={antIcon}
                    tip="uploading..."
                >
                    <div className="realtive box-border bg-cover-image w-64 h-64 rounded-md border border-solid border-image-box flex flex-col justify-center items-center gap-2">
                        {!Object.keys(featureImage).length ? (
                            <div className="">
                                <DokanIcons icon="#cloud_up" size="20" />
                            </div>
                        ) : (
                            <div className="">
                                <div
                                    className="relative border border-image-box w-32 h-32"
                                    onMouseOver={() => setHover(true)}
                                    onMouseLeave={() => setHover(false)}
                                >
                                    <img
                                        src={featureImage.src}
                                        alt="img"
                                        className="avatar-multi-uploader w-full h-full p-1"
                                    />
                                    {isHovered && (
                                        <button
                                            type="button"
                                            className="image-box-dismiss"
                                            onClick={() => removeCoverImage({})}
                                        >
                                            <DokanIcons icon="#cross_oval" size="6" />
                                        </button>
                                    )}
                                </div>
                            </div>
                        )}

                        <div className="hover:text-tertiary">
                            <button
                                type="button"
                                className="focus:outline-none"
                                onClick={inputFile}
                            >
                                <strong>browse</strong> to choose cover photo
                            </button>
                        </div>
                    </div>
                </Spin>
            </div>
        </>
    );
}

export default DokanUpload;
